import { __decorate, __metadata, __param } from "tslib";
import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
var LoggingService = /** @class */ (function () {
    function LoggingService(http) {
        this.http = http;
        this.apiRoot = '/workplaceLivingServicesREST/log/exception';
    }
    LoggingService.prototype.log = function (request) {
        return this.http.post(this.apiRoot, request).toPromise();
    };
    LoggingService = __decorate([
        __param(0, Inject(HttpClient)),
        __metadata("design:paramtypes", [HttpClient])
    ], LoggingService);
    return LoggingService;
}());
export { LoggingService };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nZ2luZy5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vd29ya3BsYWNlTGl2aW5nU2VydmljZXMvc3JjL2FwcC9zaGFyZWQvZ2xvYmFsLWVycm9yLWhhbmRsZXIvbG9nZ2luZy5zZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsVUFBVSxFQUFDLE1BQU0sc0JBQXNCLENBQUM7QUFDaEQsT0FBTyxFQUFDLE1BQU0sRUFBQyxNQUFNLGVBQWUsQ0FBQztBQVVyQztJQUlFLHdCQUErQyxJQUFnQjtRQUFoQixTQUFJLEdBQUosSUFBSSxDQUFZO1FBRnZELFlBQU8sR0FBVyw0Q0FBNEMsQ0FBQztJQUd2RSxDQUFDO0lBRU0sNEJBQUcsR0FBVixVQUFXLE9BQW9CO1FBQzdCLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQU0sSUFBSSxDQUFDLE9BQU8sRUFBRSxPQUFPLENBQUMsQ0FBQyxTQUFTLEVBQUUsQ0FBQztJQUNoRSxDQUFDO0lBVFUsY0FBYztRQUlMLFdBQUEsTUFBTSxDQUFDLFVBQVUsQ0FBQyxDQUFBO3lDQUFlLFVBQVU7T0FKcEQsY0FBYyxDQVUxQjtJQUFELHFCQUFDO0NBQUEsQUFWRCxJQVVDO1NBVlksY0FBYyJ9